import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { SharedModule } from '../shared.module';
import { catchError, map } from 'rxjs/operators';
import { toDMS } from 'maptoolz';

//SERVICES
import { ConfigService } from '../services/config.service';
import { StorageService } from '../services/storage.service';
//MODELS
import { Product } from '../models/product.interface';
import { Observable, of, Subscriber } from 'rxjs';
import { CompassApiResponse } from '../models/compass-api-response.interface';
import { CompassApiStatusEnum } from '../models/compass-api-status-enum';
import { CompassApiGetResults } from '../models/compass-api-get-results.interface';
import { VendorCurrency } from '../models/vendor-currency.interface';
import { Location } from '../models/location.interface';


@Injectable({providedIn: SharedModule})
export class CompassAPIProductsService {

	public params = new URLSearchParams();
	public config: any;
	public baseUrl: string;

	constructor(
		private httpClient: HttpClient,
		private _configService: ConfigService,
		private _storageService: StorageService
	) { 

		this.config = this._configService.getCompassApi();
		//console.log('CompassAPIProductsService.config:', this.config);
		this.baseUrl = this.config.baseUrl + 'products';
	}


	/**
	 * Get Products
	 * @param search 
	 * @param vendorId 
	 * @param destinationId 
	 * @param statusId 
	 * @param limit 
	 * @param offset 
	 * @returns 
	*/
	public getProducts (search: string = null, vendorId: string = null, destinationId: string = null, productStatus: string = null, limit: number = null, offset: number = null){
		let url = new URL(this.baseUrl);
		if(search) url.searchParams.append('SearchTerm', search);
		if(vendorId) url.searchParams.append('vendorId', vendorId);
		if(destinationId) url.searchParams.append('destinationId', destinationId);
		if(productStatus) url.searchParams.append('productStatus', productStatus);
		if(limit)  url.searchParams.append('limit', String(limit));
		if(offset)  url.searchParams.append('offset', String(offset));
		//console.log('API.getProducts().url', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getProducts.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					const Products: Product[] = res.results;
					const getResults: CompassApiGetResults = {
						total: res.total,
						results: Products
					}
					return getResults;
					//return Products;
				} else {
					return res;
				}
			}));
	}





	/**
	 * Get Product by ID 
	 * @param id 
	 * @param includeVendor 
	 * @param includeDestination 
	 * @param includeRegion 
	 * @param forVoucher 
	 * @returns 
	*/
	public getProductById (id: string, includeVendor: boolean = false, includeDestination: boolean = false, includeRegion: boolean = false, forVoucher: boolean = false): Observable<Product|CompassApiResponse>{
		let url = new URL(this.baseUrl + '/' + id);
		if(includeVendor) url.searchParams.append('includeVendor', String(includeVendor));
		if(includeDestination) url.searchParams.append('includeDestination', String(includeDestination));
		if(includeRegion) url.searchParams.append('includeRegion', String(includeRegion));
		if(forVoucher) url.searchParams.append('forVoucher', String(forVoucher));
		//console.log('API.getProductById().url:', String(url));
		//console.log('API.getProductById().headers:',  this.config.headers);

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(
				catchError(err => of({"error": err}))//.error
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getProductById.res:', res);
				//console.log('API.getProductById.res:', JSON.stringify(res));
				if(res.status == CompassApiStatusEnum.ok) {
					let product: Product = res.result;
					product.useName = product.displayName ? product.displayName : product.name;
					//this._storageService.setProduct(id, product);
					return product;
				} else {
					return res;
				}
			}));
	}

	public getProductByIdPromise(id: string): Promise<Product|null>{
		//console.log('API.getProductByIdPromise.id:', id);
		return this.getProductById(id).toPromise().then(res => (res as Product).id?res:null);
	}


	/**
	 * Get Product by ID or Slug
	 * /products/{regionSlug}/{destinationSlug}/{productSlug}
	 * @param regionSlug 
	 * @param destinationSlug 
	 * @param productSlug 
	 * @returns 
	*/
	public getProductByRegDestProdSlug (regionSlug: string, destinationSlug: string, productSlug: string): Observable<Product|CompassApiResponse>{
		//let url = ;
		let url = new URL(this.baseUrl + '/' + regionSlug + '/' + destinationSlug + '/' + productSlug);
		//url.searchParams.append('RequestSiteContext', this.config.RequestSiteContext);
		//console.log('API.getProductByRegDestProdSlug().url:', String(url));
		//console.log('API.getProductByRegDestProdSlug().headers:', this.config.headers);

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(
				catchError(err => of({"error": err}))//.error
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getProductByRegDestProdSlug.res:', res);
				//console.log('API.getProductByRegDestProdSlug.res:', JSON.stringify(res));
				if(res.status == CompassApiStatusEnum.ok) {
					const product: Product = res.result;
					return product;
				} else {
					return res;
				}
			}));
	}




    
	/**
	 * Post (create) Products
	 * @param data:Product
	 * @returns 
	*/
	public postProducts (data:Product){
		let url = this.baseUrl,
			body = data,
			options = { 
				headers: this.config.headers,
			};
		//console.log('API.postProducts().url', url);
		// console.log('postProducts().body', body);
		// console.log('postProducts().options', options);
		//return this.httpClient.post(url, body, options);

		return this.httpClient
			.post(url, body, options)
			.pipe(
				catchError(err => of({"error": err}))//.error
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.postProducts.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else { 
					return res;
				}
			}));
	}


	/**
	 * Put (update) Products
	 * @param id 
	 * @param data:Product
	 * @returns 
	*/
	public putProducts (id: string, data:Product): Observable<Product>{
		let url = this.baseUrl + '/' + id,
			body = data,
			options = { 
				headers: this.config.headers,
			};
		//console.log('putProducts().url:', url);
		// console.log('putProducts().body', body);
		// console.log('putProducts().options', options);

		return this.httpClient
			.put(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.putProducts.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else { 
					return res;
				}
			}));
	}


	/**
	 * Delete Product
	 * @param id 
	 * @returns 
	*/
	public deleteProducts (id: string){
		let url = this.baseUrl + '/' + id,
			options = { 
				headers: this.config.headers,
			};
		//console.log('deleteProducts().url', url);
		//return this.httpClient.delete(url, options);
		return this.httpClient
			.delete(url, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.deleteProducts.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else { 
					return res;
				}
			}));
	}






	
	/**
	 * Post (create) Products assets
	 * @param slug
	 * @param data:form data
	 * @returns
	*/
	public postProductsAssets (slug:string, data:any){
		let url = this.baseUrl + '/' + slug + '/assets',
			body = data,
			options = {
				headers: this.config.headersMulti,
			};
		// console.log('API.postProductsAssets().url', url);
		// console.log('API.postProductsAssets().body', body);
		// console.log('API.postProductsAssets().options', options);

		return this.httpClient
			.post(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.postProductsAssets.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.results;
				} else {
					return res;//uses error
				}
			}));
	}


	/**
	 * Delete Products assets
	 * @param slug
	 * @param id
	 * @returns
	*/
	public deleteProductsAssets (slug:string, id:string){
		let url = this.baseUrl + '/' + slug + '/assets/' + id,
			//body = data,
			options = {
				headers: this.config.headers,
			};
		//console.log('API.deleteProductsAssets().url', url);
		//console.log('API.deleteProductsAssets().options', options);

		return this.httpClient
			.delete(url, options)
			.pipe(
				catchError(err => of({"error": err}))//err.error
			)
			.pipe(map((res: CompassApiResponse) => {
				///console.log('API.deleteProductsAssets.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else {
					return res;//uses error
				}
			}));
	}






	/**
	 * Submit product For Approval
	 * @param id 
	 * @returns 
	*/
	public submitForApproval (id: string){//: Observable<Product>
		let url = this.baseUrl + '/' + id + '/submitforapproval';
		//console.log('submitForApproval().url:', url);

		return this.httpClient
			.put(url, { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.submitForApproval.res:', res);
				//console.log('API.submitForApproval.res:', JSON.stringify(res));
				if(res.status == CompassApiStatusEnum.ok) {
					const product: Product = res.result;
					return product;
				} else {
					return null;
				}
			}));
	}





	public processProductLocations(locations: Location[]) {
		//console.log('processProductLocations().locations:', locations);
		locations.forEach(location => {

			location.address.addressDisplay = '';
			//if(location.name) location.address.addressDisplay += '<b>' + location.name + '</b><br/>';
			if(location.address.streetAddress) location.address.addressDisplay += '' + location.address.streetAddress;
			if(location.address.extendedAddress) location.address.addressDisplay += ' ' + location.address.extendedAddress;
			if(location.address.locality) location.address.addressDisplay += ' &nbsp;&nbsp; ' + location.address.locality;
			if(location.address.region) location.address.addressDisplay += ', ' + location.address.region;
			if(location.address.postalCode) location.address.addressDisplay += ' ' + location.address.postalCode;
			if(location.address.country) location.address.addressDisplay += ' ' + location.address.country;
			
			if(location.address.latLng){
				let dmsArr = toDMS([location.address.latLng.lat, location.address.latLng.lng]);
				location.address.latLngDisplay = dmsArr[0].lat + ' ' + dmsArr[0].long;
				//console.log('location.address.latLngDisplay', location.address.latLngDisplay);
				location.address.addressDisplay += '<br/><span class="text-small">' + location.address.latLngDisplay + '</span>';
			}
			//console.log('location.address.addressDisplay', location.address.addressDisplay);
		});	

		return locations;
	}

}